module.exports = __webpack_public_path__ + "1979_1980.jpg";